import AcademicAchievement from './AcademicAchievement.component';

export default AcademicAchievement;
